import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Main from "./components/Main";
import About from "./components/About";
import BackgroundParticles from "./components/BackgroundParticles";
import Experience from "./components/Experience";
import Knowledge from "./components/Knowledge";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ScrollReveal from "./components/ScrollReveal";
import PrivacyPolicy from "./components/PrivacyPolicy";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles/global.css";
import "./styles/global.mobile.css";

import { LanguageProvider } from "./context/LanguageContext";

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <LanguageProvider>
      <Router>
        <Navbar />
        <BackgroundParticles />
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Main />

                <ScrollReveal delay={0.3}>
                  <About />
                </ScrollReveal>

                <ScrollReveal delay={0.3}>
                  <Experience />
                </ScrollReveal>

                <ScrollReveal delay={0.3}>
                  <Knowledge />
                </ScrollReveal>

                <ScrollReveal delay={0.3}>
                  <Contact />
                </ScrollReveal>
              </>
            }
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>

        <Footer />
      </Router>
    </LanguageProvider>
  </React.StrictMode>
);
